import React from 'react';
import LogInForm from './components/LogInForm';

const LogIn = () => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            <span className="account__logo">
              {' '}
              Школа
              <span className="account__logo-accent"> Дмитрия Карпачева</span>
            </span>
          </h3>
          <h4 className="account__subhead subhead">Административная панель</h4>
        </div>
        <LogInForm />
      </div>
    </div>
  </div>
);

export default LogIn;
